var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoHover(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 931,
    height: 149,
    viewBox: "0 0 931 149",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip393_3116"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "logo",
    width: 931,
    height: 149,
    fill: "white",
    fillOpacity: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip393_3116)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M24.82 134.41L24.82 14.34L50.8 14.34L50.8 61.98L104.21 61.98L104.21 14.34L130.19 14.34L130.19 134.41L104.21 134.41L104.21 83.88L50.8 83.88L50.8 134.41L24.82 134.41Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M186.24 134.41L186.24 86.05L139.57 14.34L169.89 14.34L199.72 62.7L200.44 62.7L230.03 14.34L258.66 14.34L212.47 86.05L212.47 134.41L186.24 134.41Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M376.53 134.41L376.53 14.34L472.52 14.34L472.52 35.75L402.76 35.75L402.76 62.46L464.34 62.46L464.34 83.64L402.76 83.64L402.76 113L473.48 113L473.48 134.65L376.53 134.65L376.53 134.41Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M563.94 134.41L563.94 14.34L590.16 14.34L590.16 61.98L643.32 61.98L643.32 14.34L669.31 14.34L669.31 134.41L643.32 134.41L643.32 83.88L590.16 83.88L590.16 134.41L563.94 134.41Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M741 136.58C728.25 136.58 717.18 134.41 708.04 129.84C698.9 125.27 691.68 118.29 686.87 109.15C682.06 100 679.41 88.45 679.41 74.5C679.41 60.3 681.82 48.75 686.87 39.6C691.68 30.46 698.9 23.72 708.04 19.15C717.18 14.58 728.25 12.41 741 12.41C753.99 12.41 765.05 14.58 774.19 19.15C783.34 23.72 790.31 30.46 795.36 39.6C800.18 48.75 802.82 60.54 802.82 74.5C802.82 88.45 800.42 100 795.36 109.15C790.55 118.29 783.34 125.27 774.19 129.84C765.05 134.17 753.99 136.58 741 136.58ZM741 115.16C746.77 115.16 751.82 114.44 756.15 112.76C760.48 111.07 764.09 108.67 766.98 105.3C769.86 101.93 772.03 98.08 773.71 93.26C775.16 88.45 775.88 83.16 775.88 77.14L775.88 71.61C775.88 65.35 775.16 59.82 773.71 55.24C772.27 50.43 769.86 46.34 766.98 43.21C764.09 40.08 760.48 37.68 756.15 35.99C751.82 34.31 746.77 33.59 741 33.59C735.46 33.59 730.41 34.31 726.08 35.99C721.75 37.68 718.14 40.08 715.25 43.21C712.37 46.34 710.2 50.43 708.76 55.24C707.32 60.06 706.59 65.59 706.59 71.61L706.59 77.14C706.59 83.16 707.32 88.69 708.76 93.26C710.2 98.08 712.37 101.93 715.25 105.3C718.14 108.67 721.75 111.07 726.08 112.76C730.41 114.44 735.46 115.16 741 115.16Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M812.93 134.41L812.93 14.34L875.47 14.34C884.13 14.34 891.35 16.02 897.12 19.15C902.9 22.28 907.23 26.85 910.35 32.62C913.24 38.4 914.93 45.38 914.93 53.32C914.93 61.26 913.48 68.24 910.35 74.01C907.23 80.03 902.66 84.6 896.88 87.73C890.87 91.1 883.65 92.54 874.99 92.54L839.39 92.54L839.39 134.41L812.93 134.41ZM838.91 71.13L870.9 71.13C876.43 71.13 880.52 69.44 883.65 66.31C886.78 63.19 888.22 58.85 888.22 53.08C888.22 49.23 887.5 46.1 886.3 43.45C885.1 40.81 883.17 38.88 880.52 37.44C878.12 35.99 874.75 35.27 870.9 35.27L838.91 35.27L838.91 71.13Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path",
    d: "M280.79 135.14C276.94 135.14 272.85 134.41 268.52 132.01C255.05 124.79 254.08 108.18 253.6 100.97L253.6 100.24C253.12 91.58 254.08 82.92 256.25 74.5C254.08 74.5 252.16 74.74 249.99 75.22L240.13 76.9L240.13 57.17L246.87 55.49C252.64 54.52 258.41 54.28 264.19 54.52C271.16 42.01 281.03 31.18 293.06 23.96C307.73 15.06 320.72 14.1 326.98 14.1C331.31 14.1 339.97 14.34 348.87 19.87C357.53 25.17 361.86 32.14 363.78 36.96C369.8 51.39 365.95 68.48 354.16 78.59C349.59 82.68 344.3 84.36 342.37 85.32C336.36 87.49 329.86 88.45 325.77 87.73L315.91 86.77L315.91 66.79L325.05 67.76C328.66 68 332.27 67.76 335.64 66.55C337.08 66.07 339.49 65.11 341.41 63.43C347.18 58.37 347.91 49.95 345.5 44.66C344.3 41.53 341.89 39.12 338.52 36.96C334.19 34.31 329.86 34.31 326.74 34.07C323.37 34.07 314.47 34.55 303.64 41.05C296.42 45.38 290.17 51.39 285.36 58.61C288.73 59.82 292.09 61.74 295.22 64.63C301.72 70.4 304.12 76.9 305.32 80.03C310.62 93.99 311.82 123.1 294.98 131.28C292.57 132.73 287.28 135.14 280.79 135.14ZM276.46 76.9C275.73 79.31 274.53 83.16 274.05 87.97C273.09 96.39 273.09 112.76 280.06 115.16C282.23 115.88 284.15 115.16 284.39 114.92C291.37 112.03 292.09 96.63 288.48 88.69C286.8 84.84 283.19 80.99 281.99 79.55C281.03 79.31 280.55 78.83 276.46 76.9Z",
    fill: "#FFFFFF",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoHover);
export default __webpack_public_path__ + "static/media/logo-hover.3f7e3ad560446eb35b1acc09d81b3492.svg";
export { ForwardRef as ReactComponent };